var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-fixed",class:{ gray: _vm.gray }},[_c('swiper',{ref:"subSwiper",staticClass:"sub-swiper",class:{ abheight: _vm.abheight },attrs:{"options":_vm.swiperOptions}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }